import RestrictionsDecorate from '../../../../facade/restrictions/decorate';

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    const restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    const getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );

    return getRestrictions('tablecolors').length || getRestrictions('tablecolors-library').length ||
      getRestrictions('textcolors').length || getRestrictions('textcolors-library').length;
  }
}, { haveOptions: function () { return false; } });
